module.exports = __webpack_public_path__ + "img/logo-horizontal-dark-wt-next-spin.bcbed8f6.png";